import type { RouteConfig } from '@/config/routes';

export const ADMIN_CLAIM_UI = 'admin_claim_ui';
export const ADMIN_USERS_UI = 'admin_users_ui';
export const ADMIN_DEEL_CONTRACT_ID = 'admin_deel_contract_id';

const FEATURE_GATED_ROUTES: Record<string, string[]> = {
  [ADMIN_USERS_UI]: ['/admin/users/:userId'],
};

export function filterRoutesByFeatureFlags<T extends RouteConfig>(
  routes: readonly T[],
  flags: Record<string, boolean> = {},
): T[] {
  return routes.filter((route) =>
    Object.entries(FEATURE_GATED_ROUTES).every(
      ([flag, paths]) => flags?.[flag] || !paths.includes(route.path),
    ),
  );
}

export function isFeatureEnabled(flags: Record<string, boolean> = {}, flag: string): boolean {
  return Boolean(flags[flag]);
}
